module.exports = "/_next/static/images/5429794c706994a384f7f80f9cdba238-limit.png";